import {
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
import { FiMoreVertical, FiSearch } from "react-icons/fi";
import { TbArrowsSort, TbSettings } from "react-icons/tb";
import { useEffect, useState } from "react";
import { LogoutAlertDialog } from "../../../components/LogoutAlertDialog";
import AddTax from "./AddTax";
import { deleteATax, getAllTaxes } from "../../../actions/management.action";
import EditTax from "./EditTax";
import { Loading } from "../../../components/Loading";
import { ImFilter } from "react-icons/im";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";

const ViewTaxes = () => {
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [query, setQuery] = useState("");
  const onOpenAlert = () => setIsAlertOpen(true);
  const onCloseAlert = () => setIsAlertOpen(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const standardOptions = [10, 20];

  const perPageOptions = (() => {
    // If no data yet, show all standard options
    if (items.length === 0) return standardOptions;

    // If items.length less than smallest standard option
    if (items.length < standardOptions[0]) return [items.length];

    // Otherwise, show all options <= items.length
    const filtered = standardOptions.filter((num) => num <= items.length);

    // If current itemsPerPage is greater than items.length and not in filtered, add it
    if (itemsPerPage > items.length && !filtered.includes(itemsPerPage)) {
      filtered.push(itemsPerPage);
      filtered.sort((a, b) => a - b);
    }

    return filtered;
  })();

  const totalPages = Math.ceil(items.length / itemsPerPage);

  //need to add items per page limit in api and use effect and add set currentPage when anither page is clicked
  useEffect(() => {
    // loadData();
    getTaxesData();
  }, [currentPage]);

  const getTaxesData = async () => {
    try {
      let res = await getAllTaxes(query);
      setItems(res.data);
    } catch (error) {
      console.log(error);
      toast({
        title: "Error",
        description: "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteATaxInfo = async (id) => {
    if (!window.confirm("Are you sure you want to delete this tax?")) return;
    try {
      let res = await deleteATax(id);
      if (res?.success) {
        toast({
          title: "Tax Deleted Successfully",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        getTaxesData();
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Error",
        description: "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    let timer = setTimeout(() => {
      getTaxesData();
    }, 1000);
    return () => clearTimeout(timer);
  }, [query]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box px={4} py={6}>
      <Flex
        justifyContent={{ base: "center", md: "space-between" }}
        alignItems={{ base: "flex-start", md: "center" }}
        mb={6}
        flexDir={{ base: "column", md: "row" }}
      >
        <BreadCrumbMaker
          items={[
            // { link: "/", title: "Dashboard" },
            { link: "/management", title: "Operations Setup" },
            { link: "/management/taxes", title: "Taxes", on: true },
          ]}
        />
        <AddTax reload={getTaxesData} />
      </Flex>

      <Flex justifyContent={"space-between"} alignItems={"center"} mb={6}>
        <Text fontSize="xl" color="#333B69" fontWeight={"bold"}>
          Taxes
        </Text>
        <Flex w="100%" maxW="600px" gap={3} justifyContent={"flex-end"}>
          <Flex
            gap={0}
            alignItems="center"
            // border="1px"
            // borderColor="gray.200"
            w="100%"
            maxW="300px"
            bg="white"
            px={3}
            h="40px"
            borderRadius={"13"}
          >
            <FiSearch color="#718EBF" fontSize="1rem" />
            <Input
              placeholder="Search for something"
              border="none"
              onChange={(e) => setQuery(e.target.value)}
              _focus={{ outline: "none", boxShadow: "none" }}
              fontSize="sm"
              h="full"
              _placeholder={"#718EBF"}
            />
          </Flex>
          <Flex
            gap={2}
            alignItems="center"
            justifyContent="center"
            // border="1px"
            // borderColor="gray.200"
            w="100%"
            maxW="91px"
            bg="white"
            px={3}
            h="40px"
            borderRadius={"13"}
            cursor="pointer"
          >
            <TbArrowsSort color="#718EBF" fontSize="1rem" />
            <Text fontSize="sm" color="#718EBF">
              Sort
            </Text>
          </Flex>
          <Flex
            gap={2}
            alignItems="center"
            justifyContent="center"
            // border="1px"
            // borderColor="gray.200"
            w="100%"
            maxW="91px"
            bg="white"
            px={3}
            h="40px"
            borderRadius={"13"}
            cursor="pointer"
          >
            <ImFilter color="#718EBF" fontSize="1rem" />
            <Text fontSize="sm" color="#718EBF">
              Filter
            </Text>
          </Flex>
          <Flex
            // gap={2}
            alignItems="center"
            justifyContent="center"
            // border="1px"
            // borderColor="gray.200"
            w="100%"
            maxW="40px"
            bg="white"
            // px={3}
            h="40px"
            borderRadius="full"
            cursor="pointer"
          >
            <TbSettings color="#718EBF" fontSize="1.3rem" />
          </Flex>
        </Flex>
      </Flex>
      {/* main */}
      <Box p={7} bg={"white"} overflowX={"auto"} borderRadius={"3xl"}>
        <Table size="sm" bg={"white"} fontSize={"small"}>
          <Thead>
            <Tr>
              <Th color={"#718EBF"}>S.No</Th>
              <Th color={"#718EBF"}>State</Th>
              <Th color={"#718EBF"}>Toll Tax</Th>
              <Th color={"#718EBF"}>State Tax</Th>
              <Th color={"#718EBF"}>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {items?.map((item, index) => (
              <Tr key={item._id}>
                <Td>{index + 1}</Td>
                <Td>{item.state}</Td>
                <Td>{item.tollTax}</Td>
                <Td>{item.stateTax}</Td>
                <Td>
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      icon={<FiMoreVertical />}
                      variant="ghost"
                      size="sm"
                    />
                    <MenuList
                      minW="150px"
                      p={2}
                      borderRadius={0}
                      boxShadow="lg"
                    >
                      <EditTax
                        data={item}
                        id={item?._id}
                        reload={getTaxesData}
                      />
                      <Box
                        _hover={{
                          bg: "gray.100",
                          color: "red.500",
                          cursor: "pointer",
                        }}
                        p={2}
                        borderRadius={0}
                        transition="background-color 0.2s ease"
                      >
                        <LogoutAlertDialog
                          isOpen={isAlertOpen}
                          onOpen={onOpenAlert}
                          callback={() => deleteATaxInfo(item?._id)}
                          onClose={onCloseAlert}
                          title={"Delete"}
                          heading={"Do you want to delete this tax ?"}
                          buttonViewContent={<Text>Delete</Text>}
                        />
                      </Box>
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Flex justifyContent="space-between" alignItems="center" mt={4} gap={2}>
          <Flex align="center" gap={4} wrap="wrap" justify="center" mt={4}>
            <Text fontSize="sm" color={"#8B909A"}>
              Showing:
            </Text>
            <Select
              size="sm"
              width="fit-content"
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              {perPageOptions.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </Select>
            <Text fontSize="sm" color={"#8B909A"}>
              {" "}
              of {items.length}
            </Text>
          </Flex>
          <Flex alignItems="center" mt={4} gap={2}>
            <Button
              size="sm"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              isDisabled={currentPage === 1}
            >
              <GoChevronLeft />
            </Button>
            {(() => {
              let startPage = 1;
              let endPage = totalPages;

              if (totalPages > 5) {
                if (currentPage <= 3) {
                  startPage = 1;
                  endPage = 5;
                } else if (currentPage >= totalPages - 2) {
                  startPage = totalPages - 4;
                  endPage = totalPages;
                } else {
                  startPage = currentPage - 2;
                  endPage = currentPage + 2;
                }
              }

              const pagesToShow = [];
              for (let i = startPage; i <= endPage; i++) {
                pagesToShow.push(
                  <Button
                    key={i}
                    size="sm"
                    variant={i === currentPage ? "solid" : ""}
                    colorScheme={i === currentPage ? "#0F60FF" : ""}
                    bgColor={i === currentPage ? "#0F60FF" : "#F1F2F6"}
                    onClick={() => setCurrentPage(i)}
                  >
                    <Text color={i === currentPage ? "#FFFFFF" : "#8B909A"}>
                      {i}
                    </Text>
                  </Button>,
                );
              }
              return pagesToShow;
            })()}
            <Button
              size="sm"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              isDisabled={currentPage === totalPages}
            >
              <GoChevronRight />
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default ViewTaxes;
